import React from 'react'
import '../Styles/UI.css'

const FilterButton = () => {
  return (
    <div>
      <button className='filter-btn'>Filter</button>
    </div>
  )
}

export default FilterButton
